import angular from 'angular';
import {
  ssDialogService,
  orgDataService,
  loaderService,
} from 'app/services';
import {
  confirmDialog,
  actionIcon,
  alerts
} from 'app/components/global';
import controller from './customer.controller';
import directive from './customer.directive';


export default angular.module('admin.userAdmin.editUserCustomerAssignmentsDialog.customer', [
  actionIcon,
  confirmDialog,
  ssDialogService,
  loaderService,
  alerts,
  orgDataService
])
  .directive('uaCustomer', directive)
  .controller('UACustomerController', controller)
  .name;

console.log('admin.userAdmin.editUserCustomerAssignmentsDialog.customer created');
